module.exports = __webpack_public_path__ + "img/logo-dusdata-s.7ea2cf16.png";